import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import DeleteButton from "components/Button/DeleteButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DateInsertFormat, DropdownGender, DropdownMaritalStatus, DropdownNationality, DropdownPosition, DropdownReligion, EmptyString, FormTypeAdd, FormTypeEdit, SmallDateFormat } from "utils/Constant";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiCreateEmployeeLocation, ApiDeleteEmployeeLocation, ApiDeleteEmployee, ApiGetEmployeeById, ApiGetEmployeeLocationList, ApiGetEmployeeLocationOptions, ApiInsertEmployee, ApiUpdateEmployee } from "utils/constants/api";
import Dropdown from "components/Input/Dropdown";
import { GetStatus, removeNonNumeric } from "utils/helpers";
import moment from "moment";
import UnDeleteButton from "components/Button/UnDeleteButton";
import TrashIcon from "assets/icon/TrashIcon";
import DatePicker from "components/Input/DatePicker";
import ImageIcon from "assets/icon/ImageIcon";
import PlusIcon from "assets/icon/PlusIcon";
import KeyIcon from "assets/icon/KeyIcon";

export default function EmployeeForm(){
    let navigate = useNavigate()

    const { fetch: deleteEmployee } = useFetch(ApiDeleteEmployee)
    const { fetch: getEmployeeById } = useFetch(ApiGetEmployeeById)
    const { fetch: insertEmployee } = useFetch(ApiInsertEmployee)
    const { fetch: updateEmployee } = useFetch(ApiUpdateEmployee)
    const { fetch: getLocation } = useFetch(ApiGetEmployeeLocationOptions)
    const { fetch: getEmployeeLocation, data: employeeLocationList } = useFetch(ApiGetEmployeeLocationList)
    const { fetch: createEmployeeLocation } = useFetch(ApiCreateEmployeeLocation)
    const { fetch: deleteEmployeeLocation } = useFetch(ApiDeleteEmployeeLocation)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramEmployeeId = queryString.get("employeeId")

    const [employeeName, setEmployeeName] = useState(EmptyString)
    const [idNumber, setIdNumber] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [ward, setWard] = useState(EmptyString)
    const [district, setDistrict] = useState(EmptyString)
    const [city, setCity] = useState(EmptyString)
    const [province, setProvince] = useState(EmptyString)
    const [postalCode, setPostalCode] = useState(EmptyString)
    const [gender, setGender] = useState(DropdownGender[0].value)
    const [religion, setReligion] = useState(DropdownReligion[0].value)
    const [placeOfBirth, setPlaceOfBirth] = useState(EmptyString)
    const [dateOfBirth, setDateOfBirth] = useState(EmptyString)
    const [maritalStatus, setMaritalStatus] = useState(EmptyString)
    const [nationality, setNationality] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)
    const [division, setDivision] = useState(DropdownPosition[0].value)
    const [dateOfJoin, setDateOfJoin] = useState(EmptyString)
    const [location, setLocation] = useState(EmptyString)
    const [locationOptions, setLocationOptions] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [photoIdFile, setPhotoIdFile] = useState(EmptyString)
    const [photoSKKBFile, setPhotoSKKBFile] = useState(EmptyString)
    const [photoDomicileFile, setPhotoDomicileFile] = useState(EmptyString)
    const [photoIdFileUrl, setPhotoIdFileUrl] = useState(EmptyString)
    const [photoSKKBFileUrl, setPhotoSKKBFileUrl] = useState(EmptyString)
    const [photoDomicileFileUrl, setPhotoDomicileFileUrl] = useState(EmptyString)

    const handlePhotoIdChange = (e) => {
        setPhotoIdFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setPhotoIdFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }
    const handlePhotoSKKBChange = (e) => {
        setPhotoSKKBFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setPhotoSKKBFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }
    const handlePhotoDomicileChange = (e) => {
        setPhotoDomicileFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setPhotoDomicileFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }
    
    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    
    // Button Event
    const saveBtnClick = () => {
        if(formValidation()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if(formType === FormTypeAdd){
                    fInsertEmployee().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateEmployee().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})
         
            fDeleteEmployee(paramEmployeeId, status).then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    const addLocationBtnClick = () => {
        setLoading({isOpen: true})

        fInsertEmployeeLocation().then(() => {
            fGetEmployeeLocationList().then(() => {
                fGetLocationList().then(() => {
                    setLoading({isOpen: false})
                })
            })
        })
    }
    const deleteEmployeeLocationBtnClick = (id) => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fDeleteEmployeeLocation(id).then(() => {
                fGetEmployeeLocationList().then(() => {
                    fGetLocationList().then(() => {
                        setLoading({isOpen: false})
                    })
                })
            })
        }}})
    }
    const accessBtnClick = () => {
        navigate("/employee-access?employeeId=" + paramEmployeeId + "&employeeName=" + employeeName)
    }

    // API Calls
    async function fInsertEmployee(){
        let data = new FormData()

        data.append('EmployeeName', employeeName)
        data.append('IdNumber', idNumber)
        data.append('Address', address)
        data.append('Ward', ward)
        data.append('District', district)
        data.append('City', city)
        data.append('Province', province)
        data.append('PostalCode', postalCode)
        data.append('GenderId', gender)
        data.append('ReligionId', religion)
        data.append('PlaceOfBirth', placeOfBirth)
        data.append('DateOfBirth', moment(dateOfBirth).format(DateInsertFormat))
        data.append('MaritalStatusId', maritalStatus)
        data.append('NationalityId', nationality)
        data.append('Phone', phone)
        data.append('DivisionId', division)
        data.append('DateOfJoin', moment(dateOfJoin).format(DateInsertFormat))
        data.append('PhotoId', photoIdFile)
        data.append('PhotoSKKB', photoSKKBFile)
        data.append('PhotoDomicileLetter', photoDomicileFile)

        await insertEmployee({
            data: data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            navigate("/employee") 
                        }
                    } 
                })
            }
        })
    }
    async function fInsertEmployeeLocation(){
        await createEmployeeLocation({
            data: {
                employeeId: paramEmployeeId,
                locationId: location
            }
        }).then((response) => {
            checkResponse(response)
        })
    }
    async function fDeleteEmployeeLocation(id){
        await deleteEmployeeLocation({
            data: {
                employeeLocationId: id
            }
        }).then((response) => {
            checkResponse(response)
        })
    }
    async function fUpdateEmployee(){
        let data = new FormData()

        data.append('EmployeeId', paramEmployeeId)
        data.append('EmployeeName', employeeName)
        data.append('IdNumber', idNumber)
        data.append('Address', address)
        data.append('Ward', ward)
        data.append('District', district)
        data.append('City', city)
        data.append('Province', province)
        data.append('PostalCode', postalCode)
        data.append('GenderId', gender)
        data.append('ReligionId', religion)
        data.append('PlaceOfBirth', placeOfBirth)
        data.append('DateOfBirth', moment(dateOfBirth).format(DateInsertFormat))
        data.append('MaritalStatusId', maritalStatus)
        data.append('NationalityId', nationality)
        data.append('Phone', phone)
        data.append('DivisionId', division)
        data.append('DateOfJoin', moment(dateOfJoin).format(DateInsertFormat))
        data.append('PhotoId', photoIdFile)
        data.append('PhotoSKKB', photoSKKBFile)
        data.append('PhotoDomicileLetter', photoDomicileFile)

        await updateEmployee({
            data: data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            navigate("/employee") 
                        }
                    } 
                })
            }
        })
    }
    async function fDeleteEmployee(employeeId, status){
        await deleteEmployee({
            data: {
                employeeId: employeeId,
                status: status
            }
        }).then((response) => {
            if (checkResponse(response)) {
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            navigate("/employee") 
                        }
                    } 
                })
            }
        })
    }
    async function fGetEmployeeById(){
        await getEmployeeById({
            data: {
                employeeId: paramEmployeeId
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let data = response.data
                
                setEmployeeName(data.employeeName)
                setDateOfJoin(data.dateOfJoin)
                setIdNumber(data.idNumber)
                setPlaceOfBirth(data.placeOfBirth)
                setDateOfBirth(data.dateOfBirth)
                setAddress(data.address)
                setWard(data.ward)
                setDistrict(data.district)
                setCity(data.city)
                setProvince(data.province)
                setPostalCode(data.postalCode)
                setGender(String(data.genderId))
                setReligion(String(data.religionId))
                setMaritalStatus(String(data.maritalStatusId))
                setNationality(String(data.nationalityId))
                setPhone(String(data.phone))
                setDivision(String(data.divisionId))
                setPhotoIdFileUrl(String(data.photoIdUrl))
                setPhotoSKKBFileUrl(data.photoSKKBUrl)
                setPhotoDomicileFileUrl(data.photoDomicileLetterUrl)
                setStatus(data.status)
                setCreateDate(moment(data.createDate).format(SmallDateFormat))
                setUpdateDate(moment(data.updateDate).format(SmallDateFormat))
                setUpdateBy(data.updateBy)
            }
        })
    }
    async function fGetLocationList(){
        await getLocation({
            data: {
                employeeId: paramEmployeeId
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let tempArray = []
                tempArray.push({label: "Select Location", value: ""})

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].locationName, value: String(response.data[i].locationId) })
                }

                setLocationOptions(tempArray)
                setLocation(tempArray[0].value)
            }
        })
    }
    async function fGetEmployeeLocationList(){
        await getEmployeeLocation({
            data: {
                employeeId: paramEmployeeId
            }
        }).then((response) => {
            checkResponse(response)
        })
    }

    // Function
    const formValidation = () => {
        if (employeeName == null || employeeName === ''){
            error('Nama harus diisi!')
            return false
        }
        if (dateOfJoin == null || dateOfJoin === '') {
            error('Tanggal bergabung harus diisi!')
            return false
        }
        if (idNumber == null || address === '') {
            error('No KTP harus diisi!')
            return false
        }
        if (placeOfBirth == null || address === '') {
            error('Tempat lahir harus diisi!')
            return false
        }
        if (dateOfBirth == null || dateOfBirth === '') {
            error('Tanggal lahir harus diisi!')
            return false
        }
        if (address == null || address === '') {
            error('Alamat harus diisi!')
            return false
        }
        if (ward == null || ward === '') {
            error('Kelurahan/Desa harus diisi!')
            return false
        }
        if (district == null || district === '') {
            error('Kecamatan harus diisi!')
            return false
        }
        if (city == null || city === '') {
            error('Kota harus diisi!')
            return false
        }
        if (province == null || province === '') {
            error('Provinsi harus diisi!')
            return false
        }


        return true
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({ isOpen: false })
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({ isOpen: false })
                    }
                },
                message: res.message
            })
            return false
        }
    }

    const error = (message) => {
        setFailModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setFailModal({ isOpen: false })
                }
            },
            message: message
        })
    }
   
    useEffect(() => {
        if (formType === FormTypeEdit){
            setLoading({isOpen: true})

            fGetEmployeeById().then(() => {
                fGetEmployeeLocationList().then(() => {
                    fGetLocationList().then(() => {
                        setLoading({isOpen: false})
                    })
                })
            })
        }
    }, [])

    return(
        <div className="flex flex-col gap-2">
            {/* HEADER */}
            <div className="flex justify-between">
                <span className="font-semibold text-2xl">Employee Detail</span>
                <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                    <span className="text-sm opacity-60">
                        Status : {GetStatus(status)} | Created Date : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | Updated By : {updateBy}
                    </span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col lg:flex-row gap-3 lg:gap-10">
                <div className="w-full sm:w-1200 flex flex-col gap-3">
                    {/* Name */}
                    <CardForm title={'Nama'}>
                        <input className="input" value={employeeName} onChange={(e) => { setEmployeeName(e.target.value.toUpperCase()) }} maxLength={100} disabled={formType === FormTypeEdit ? true : false} />
                    </CardForm>

                    {/* Date of Join */}
                    <CardForm title='Tanggal Bergabung'>
                        <DatePicker className="h-11 w-full bg-white" value={dateOfJoin} onChange={(e) => { setDateOfJoin(e) }} />
                    </CardForm>

                    {/* Id Number */}
                    <CardForm title='No KTP'>
                        <input className="input" value={idNumber} onChange={(e) => { setIdNumber(removeNonNumeric(e.target.value)) }} maxLength={16} />
                    </CardForm>

                    {/* Place of birth */}
                    <CardForm title='Tempat Lahir'>
                        <input className="input" value={placeOfBirth} onChange={(e) => { setPlaceOfBirth(e.target.value.toUpperCase()) }} maxLength={50} />
                    </CardForm>

                    {/* Date of Birth */}
                    <CardForm title='Tanggal Lahir'>
                        <DatePicker className="w-full h-11 bg-white" value={dateOfBirth} onChange={(e) => { setDateOfBirth(e) }} />
                    </CardForm>

                    {/* Address */}
                    <CardForm title='Alamat'>
                        <input className="input" value={address} onChange={(e) => { setAddress(e.target.value.toUpperCase()) }} maxLength={100} />
                    </CardForm>

                    {/* Kelurahan/Desa */}
                    <CardForm title='Kelurahan/Desa'>
                        <input className="input" value={ward} onChange={(e) => { setWard(e.target.value.toUpperCase()) }} maxLength={50} />
                    </CardForm>

                    {/* Kecamatan / Region */}
                    <CardForm title='Kecamatan'>
                        <input className="input" value={district} onChange={(e) => { setDistrict(e.target.value.toUpperCase()) }} maxLength={50} />
                    </CardForm>

                    {/* Kota */}
                    <CardForm title='Kota'>
                        <input className="input" value={city} onChange={(e) => { setCity(e.target.value.toUpperCase()) }} maxLength={50} />
                    </CardForm>

                    {/* Province */}
                    <CardForm title='Provinsi'>
                        <input className="input" value={province} onChange={(e) => { setProvince(e.target.value.toUpperCase()) }} maxLength={50} />
                    </CardForm>

                    {/* Postal Code */}
                    <CardForm title='Kode Pos'>
                        <input className="input" value={postalCode} onChange={(e) => { setPostalCode(removeNonNumeric(e.target.value)) }} maxLength={6} />
                    </CardForm>
                </div>

                <div className="w-full sm:w-1200 flex flex-col gap-3">
                    {/* Gender */}
                    <CardForm title='Jenis Kelamin'>
                        <Dropdown options={DropdownGender} value={gender} onChange={(e) => { setGender(e.value) }} placeholder={"Select Gender"} />
                    </CardForm>

                    {/* Religion */}
                    <CardForm title='Agama'>
                        <Dropdown options={DropdownReligion} value={religion} onChange={(e) => { setReligion(e.value) }} placeholder={"Select Religion"}/>
                    </CardForm>

                    {/* Marital Status */}
                    <CardForm title='Status Perekawinan'>
                        <Dropdown options={DropdownMaritalStatus} value={maritalStatus} onChange={(e) => { setMaritalStatus(e.value) }} placeholder={"Select Marital Status"}/>
                    </CardForm>

                    {/* Nationality */}
                    <CardForm title='Kewarganegaraan'>
                        <Dropdown options={DropdownNationality} value={nationality} onChange={(e) => { setNationality(e.value) }} placeholder={"Select Nationality"}/>
                    </CardForm>

                    {/* Phone */}
                    <CardForm title='No HP'>
                        <input className="input" value={phone} onChange={(e) => { setPhone(removeNonNumeric(e.target.value)) }} maxLength={14} />
                    </CardForm>

                    {/* Position */}
                    <CardForm title='Posisi'>
                        <Dropdown options={DropdownPosition} value={division} onChange={(e) => { setDivision(e.value) }} placeholder={"Select Position"} />
                    </CardForm>
                </div>
            </div>

            <div className="mt-10">
                <div>
                    <span className="text-lg font-semibold">Complimentary Document</span>
                    <hr />
                </div>
                <div className="mt-5 flex flex-col gap-3">
                    {/* Photo ID */}
                    <div>
                        <div className="flex flex-col sm:flex-row">
                            <div className="w-48 mt-2">
                                <span>Foto KTP</span>
                            </div>
                            <div className="px-4 hidden sm:block mt-2">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 flex flex-col gap-2">
                                <img
                                    className="w-full h-[180px] object-cover mx-auto border rounded-md"
                                    src={photoIdFileUrl}
                                    alt="ID"
                                />
                                <input className="hidden" id="photoId" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handlePhotoIdChange} />
                                <button onClick={() => document.getElementById('photoId').click()} 
                                    className="px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center"
                                >
                                    <ImageIcon />
                                    Add Image
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Photo Domicile */}
                    <div>
                        <div className="flex flex-col sm:flex-row">
                            <div className="w-48 mt-2">
                                <span>Surat Keterangan Domisili</span>
                            </div>
                            <div className="px-4 hidden sm:block mt-2">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 flex flex-col gap-2">
                                <img
                                    className="w-full h-[180px] object-cover mx-auto border rounded-md"
                                    src={photoDomicileFileUrl}
                                    alt="Domicile Letter"
                                />
                                <input className="hidden" id="photoDomicileLetter" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handlePhotoDomicileChange} />
                                <button onClick={() => document.getElementById('photoDomicileLetter').click()} 
                                    className="px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center"
                                >
                                    <ImageIcon />
                                    Add Image
                                </button>
                            </div>
                            {/* <div className="w-full sm:w-72">
                                
                            </div> */}
                        </div>
                    </div>

                    {/* Photo SKKB */}
                    <div>
                        <div className="flex flex-col sm:flex-row">
                            <div className="w-48 mt-2">
                                <span>SKKB</span>
                            </div>
                            <div className="px-4 hidden sm:block mt-2">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72 flex flex-col gap-2">
                                <img
                                    className="w-full h-[180px] object-cover mx-auto border rounded-md"
                                    src={photoSKKBFileUrl}
                                    alt="SKKB"
                                />
                                <input className="hidden" id="photoSKKB" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handlePhotoSKKBChange} />
                                <button onClick={() => document.getElementById('photoSKKB').click()} 
                                    className="px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center"
                                >
                                    <ImageIcon />
                                    Add Image
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`mt-10 ${formType === FormTypeEdit ? 'block' : 'hidden'}`}>
                <div>
                    <span className="text-lg font-semibold">Location Assigned</span>
                    <hr />
                </div>
                <div className="mt-5">
                    {/* location */}
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <CardForm title='Lokasi'>
                                <Dropdown options={locationOptions} value={location} onChange={(e) => { setLocation(e.value) }} placeholder={"Select Location"} />
                            </CardForm>
                            <div className="ml-0 sm:ml-4 mt-4 sm:mt-0 w-full sm:w-auto">
                                <button className="flex bg-black text-white px-4 py-2 rounded gap-2 w-full sm:w-auto justify-center" onClick={addLocationBtnClick}>
                                    <PlusIcon />
                                    <span>Add</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-5 sm:overflow-hidden sm:rounded-3xl sm:border sm:shadow-sm">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2">Location</th>
                                <th className="font-semibold w-auto sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            { employeeLocationList?.data?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2">
                                            <span>{ data.locationName }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            <button className={`button flex gap-2`} onClick={() => deleteEmployeeLocationBtnClick(data.employeeLocationId)}>
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <button className={`bg-black px-4 py-2 rounded-md flex gap-2 ${formType === FormTypeEdit ? 'block' : 'hidden'}`} onClick={accessBtnClick}>
                    <KeyIcon className="fill-white w-6" />
                    <span className="text-white">Access</span>
                </button>
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === "1" ? true : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === "2" ? true : false) : false} />
                <BackButton onClick={backBtnClick} />
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} /> )}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}

const CardForm = ({ title, children }) => {
    return(
        <div>
            <div className="flex flex-col sm:flex-row sm:items-center">
                <div className="w-48">
                    <span>{title}</span>
                </div>
                <div className="px-4 hidden sm:block">
                    <span>:</span>
                </div>
                <div className="w-full sm:w-72">
                    { children }
                </div>
            </div>
        </div>
    )        
}